module.exports = __webpack_public_path__ + "static/img/Acer_VN7_592G.d7601a84.png";